import React from "react";
import { ManageContentCategoriesContent } from "../components/CMS/Categories/ManageContentCategoriesContent";
import { ToastContainer } from "react-toastify";

export const ContentCategories = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageContentCategoriesContent />
        </div>
      </div>
    </div>
  );
};
